export default __webpack_public_path__ + "static/media/logo_branco.b2cf4ed1.svg";